if (!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class productGallery extends HTMLElement {
      constructor() {
        super()
        this.mainCarousel = null
        this.thumbnailCarousel = null
        this.nextArrow = null
        this.prevArrow = null
        this.count = parseInt(this.getAttribute('data-media-count'))
        this.mountCarousel()
      }
      mountCarousel() {
        var height, focus
        if (this.count < 5) {
          height = 'auto'
          focus = 1
        } else {
          height = 600
          focus = 'center'
        }
        const thumbnailOptions = {
          width: 104,
          height: height,
          direction: 'ttb',
          isNavigation: true,
          fixedWidth: 104,
          gap: 20,
          fixedHeight: 104,
          pagination: false,
          focus: focus,
          breakpoints: {
            768: {
              destroy: true
            }
          }
        }
        const mainOptions = {
          type: 'loop',
          arrows: true,
          pagination: false,
          perPage: 1,
          perMove: 1,
          gap: 20,
          easing: 'ease',
          width: '67vw',
          lazyLoad: 'nearby',
          breakpoints: {
            1070: {
              width: '100%',
              gap: 0,
              focus: 'center',
              type: 'loop',
              dragMinThreshold: 10,
              flickPower: 0,
              flickMaxPages: 1,
              perPage: 1,
              perMove: 1,
              drag: true,
              snap: true,
              pagination: true
            }
          }
        }
        this.mainCarousel = new Splide('#main-slider', mainOptions)
        this.thumbnailCarousel = new Splide('#thumbnail-carousel', thumbnailOptions)

        this.mainCarousel.sync(this.thumbnailCarousel).mount()
        this.thumbnailCarousel.mount()
        this.mainCarousel.refresh()
      }
    }
  )
}
